import { PRODUCER_ID, COVERHOLDER_ID } from "@/api/Model/ProductOwnerModel";

export default {
  props: {
    ProductCompanyType: {
      type: String,
      required: true,
    },
    ProductCompanyType_FK: {
      type: Number,
      required: true,
    },
  },
  methods: {
    companyTypeApiModel(postFix) {
      postFix = postFix[0].toUpperCase() + postFix.substring(1);

      if (this.ProductCompanyType_FK == PRODUCER_ID) {
        return 'producer' + postFix;
      }

      if (this.ProductCompanyType_FK == COVERHOLDER_ID) {
        return 'coverholder' + postFix;
      }
    }
  }
};
